import { updateDetailEventSummaryAttribute } from '@process-advisor/process-miner/processMiner/processMiner';

export type EventAttributeProps = {
    attribute?: string;
}

export const changeDetailEventSummaryAttribute = ({
    attribute,
}: EventAttributeProps) => updateDetailEventSummaryAttribute({
    
    attribute,
});
